import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import styles from './radioProfile.css'
import { connect } from 'react-redux'

const style = {
  color: 'red',
  fontSize: '12'
}
class RadioProfile extends Component {

  componentWillReceiveProps(nextProps) {
    const { input, dispatch, title, value, name, id, meta: { touched, error } } = this.props
    if (nextProps.meta.touched && nextProps.meta.error) {
      dispatch({
        type:'RADIO_ERROR',
        error:nextProps.meta.error
      })
    }

    if (nextProps.meta.touched && !nextProps.meta.error) {
      dispatch({
        type:'RADIO_ERROR_REMOVE'
      })
    }
  }

  render() {
    const { input, notError, title, value, name, id, meta: { touched, error } } = this.props

    return (
      <span className={styles.radio} >
          <label className={styles.radioLabel} htmlFor={id}>

            <input {...input} className={styles.radioField} id={id} type='radio' name={name}/>
            <span className={styles.radioPh}></span>
            <span>{title}</span>
          </label>

        {!notError ? (touched && error && <span style={style}>{error}</span>) :null}

      </span>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

RadioProfile = connect(
  null,
  mapDispatchToProps
)(RadioProfile)

export default CSSModules(RadioProfile, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/componentKit/RadioProfile.js